import { render, staticRenderFns } from "./ConfigIncentive.vue?vue&type=template&id=3de59a28&scoped=true&"
import script from "./ConfigIncentive.vue?vue&type=script&lang=js&"
export * from "./ConfigIncentive.vue?vue&type=script&lang=js&"
import style0 from "./ConfigIncentive.vue?vue&type=style&index=0&id=3de59a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de59a28",
  null
  
)

export default component.exports